// src/ApiWidget.js
import React, { useState, useEffect } from "react";
import SurveyScreen from "./Screens/SurveyScreen";
import API from "./API/API";
import { useLocation } from 'react-router-dom';

const useQuery = () => {
    return new URLSearchParams(useLocation().search);
};

const ApiWidget = () => {

    const query = useQuery();
    const toolId = query.get('toolId'); // 'value'

    const [data, setData] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchData = async () => {
            try {
                const result = await API.fetchProjectData(toolId);
                console.log("RESULT ",result);
                setData(result);
            } catch (error) {
                setError(error);
            } finally {
                setLoading(false);
            }
        }

        fetchData();
    }, [])

    if (loading) {
        return <div>Loading...</div>;
    }

    if (error) {
        return <div>Error: {error.message}</div>;
    }

    return (
        <div>
            <SurveyScreen project={data || {}} />
        </div>
    );
};

export default ApiWidget;
